var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.status
  }, [_c('div', {
    class: _vm.$style.stepsLine
  }, [_c('CProgressLinear', {
    class: _vm.$style.progress,
    attrs: {
      "value": _vm.finalProgressValue,
      "rounded": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    class: _vm.$style.stepsWrapper
  }, [_vm.label ? _c('span', {
    class: _vm.$style.label
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.$style.stepsText
  }, [_c('span', {
    class: _vm.$style.activeStep
  }, [_vm._v("\n        " + _vm._s(_vm.leadingZero(_vm.currentStep)) + "\n      ")]), _vm._v("\n      /\n      " + _vm._s(_vm.leadingZero(_vm.steps)) + "\n    ")])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };